import React from 'react';
import { Box, Text, IconButton, HStack } from '@cad-arc';
import { AttachmentDto } from '@mark43/cad-api';
import { AttachmentsThumbnailGrid } from './attachments-thumbnail-grid';
import { AttachmentSortOptionValue, AttachmentsPanelType } from './types';
import { useOpenEventPanel } from '~/event-panel/use-open-event-panel';

interface MergedAttachmentsGridProps {
    eventId: number;
    eventNumber: string;
    attachments: AttachmentDto[];
    entityType: AttachmentsPanelType;
    onOpenPreview?: (attachmentId: number) => void;
    sortOption: AttachmentSortOptionValue;
}

export function MergedAttachmentsGrid({
    eventId,
    eventNumber,
    attachments,
    entityType,
    onOpenPreview,
    sortOption,
}: MergedAttachmentsGridProps): React.ReactElement {
    const openEventPanel = useOpenEventPanel();

    const handleEventClick = () => {
        openEventPanel({
            eventId,
        });
    };

    return (
        <Box mb="md">
            <HStack align="center">
                <Text fontSize="xs" color="text.secondary">
                    Merged Event {eventNumber ? eventNumber : ''}
                </Text>

                <IconButton
                    size="sm"
                    variant="ghost"
                    icon="OpenNewWindow"
                    aria-label="open event"
                    onClick={handleEventClick}
                />
            </HStack>
            <AttachmentsThumbnailGrid
                isMergedAttachment
                attachments={attachments}
                entityId={eventId}
                entityType={entityType}
                entityNumber={eventNumber}
                onOpenPreview={onOpenPreview}
                variant="grid"
                uploads={[]}
                sortOption={sortOption}
                onClickRemoveFailedUpload={() => {}}
            />
        </Box>
    );
}
